import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@/constants/routes'

import { Button } from '@/components/ui'
import styles from './NotFound.module.css'

export function NotFound() {
    const navigate = useNavigate()

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <h1>404</h1>
                <h2>Página no encontrada</h2>
                <p>La página que busca no existe.</p>
                <Button
                    variant="primary"
                    onClick={() => navigate(ROUTES.home)}
                >
                    Volver al Inicio
                </Button>
            </div>
        </div>
    )
}

